export const mapTranslate = {
  published: "منتشرشده",
  notPublished: "منتشرنشده",
  inReview: "درحال بررسی",
  manager: "مدیر",
  servant: "ارائه دهنده خدمت",
};

export const SystemRole = {
  noLogedIn: 0x00,
  user: 0x01,
  admin: 0x02,
  manager: 0x04,
  servant: 0x08,
  //be careful , next item should be : 0x10 ,...
};
export const minWidth = "(min-width:600px)";

export const configs = {
  MAX_SNAKBAR: 1,
  HIDE_DURATION: 2000,
};

export const CacheNames = {
  AllBranches: "allBranches",
  AllBranchRoles: "allBranchRoles",
  GetAllReligions: "GetAllReligions",
  GetAllCountries: "GetAllCountries",
};

export const defaultAvatar = {
  male: "/icons/male.png",
  female: "/icons/female.png",
};

export const zIndexs = {
  loading: 1400,
  notification: 1500,
  body: 1300,
};

export const CityAutocompleteSearchType = {
  Fuzzy: "Fuzzy",
  Contains: "Contains",
  StartWith: "StartWith",
  Exact: "Exact",
};
